import { atom } from "jotai";
import { uniqueZapIdsAtom } from "../nodes";
import { zapUsageAtomFamily_SUSPENDS } from "./zapUsageAtomFamily_SUSPENDS";

export const successfulZapRunsAtom_SUSPENDS = atom<Promise<number>>(
  async (get) => {
    const uniqueZapIds = get(uniqueZapIdsAtom);

    const zapData = await Promise.all(
      uniqueZapIds.map(async (zapId) => {
        const usage = await get(zapUsageAtomFamily_SUSPENDS(zapId));
        return { zapId, usage };
      }),
    );

    const validZapData = zapData.filter((item) => item.usage !== null);

    return validZapData.reduce((total, item) => total + item.usage!.success, 0);
  },
);

successfulZapRunsAtom_SUSPENDS.debugLabel = "successfulZapRunsAtom_SUSPENDS";
